import * as React from 'react';
import { ArrowLeft, ArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Icon } from '../../Icon/src/Icon.js';
import { Space } from '../../Space/src/Space.js';
import modules_2fd5ce57 from '../styles/Arrows.module.less.js';

/** Inner sub-component for Carousel */
const Arrows = React.forwardRef((props, ref) => {
    const { isPrevDisabled, isNextDisabled, onPrevClick, onNextClick, ...restProps } = props;
    const cx = useStyles(modules_2fd5ce57);
    return (React.createElement(Space, { ref: ref, align: "end", justify: "end", size: 12, className: cx('arrows', 'important'), ...restProps },
        React.createElement(Icon, { className: cx('arrow', 'leftArrow', { disabled: isPrevDisabled }), size: 16, shape: "round", onClick: onPrevClick },
            React.createElement(ArrowLeft, null)),
        React.createElement(Icon, { className: cx('arrow', 'rightArrow', { disabled: isNextDisabled }), size: 16, shape: "round", onClick: onNextClick },
            React.createElement(ArrowRight, null))));
});
Arrows.displayName = 'Arrows';

export { Arrows };
//# sourceMappingURL=Arrows.js.map
